import {
  BPMedia,
  ContentItem
} from 'resources/activities/models/ContentItem.model';
import {
  ContentType,
  BPContentEngineEnum,
  ContentCreatorType,
  ContentVisibility
} from 'shared/enums/content-enums';

import { ContentArrayItem } from './collection-mutation-payload.model';

export class Collection extends ContentItem {
  contents: ContentArrayItem[];
  contents_count: number;

  constructor(
    id: string,
    old_activity_key: string,
    type: ContentType,
    engine: BPContentEngineEnum,
    display_name: string,
    description: string,
    cover_big: string,
    cover_small: string,
    media: BPMedia[],
    tags: string[],
    creator_type: ContentCreatorType,
    creator_id: string,
    visibility: ContentVisibility,
    min_content_version: number,
    created_at: string,
    updated_at: string,
    published_at: string,
    new_until: string,
    origin_custom_key: string,
    cover_box: string,
    cover_rect: string,
    draft_of: string,
    replaced_by: string,
    random_order: number,
    share_link: string,
    my_draft: string,
    labels: any,
    is_popular: boolean,
    contents: string[] = new Array<string>(),
    plays: string
  ) {
    super(
      id,
      old_activity_key,
      type,
      engine,
      display_name,
      description,
      cover_big,
      cover_small,
      media,
      tags,
      creator_type,
      creator_id,
      visibility,
      min_content_version,
      created_at,
      updated_at,
      published_at,
      new_until,
      origin_custom_key,
      cover_box,
      cover_rect,
      draft_of,
      replaced_by,
      random_order,
      share_link,
      my_draft,
      labels,
      is_popular,
      false,
      false,
      false,
      false,
      plays
    );
    this.contents = contents?.map((v) => {
      return { id: v };
    });
    this.contents_count = this.contents?.length ?? 0;
  }

  static fromDto(content: any) {
    return new Collection(
      content.id,
      content.old_activity_key,
      content.type,
      content.engine,
      content.display_name,
      content.description,
      content.cover_big,
      content.cover_small,
      content.media,
      content.tags,
      content.creator_type,
      content.creator_id,
      content.visibility,
      content.min_content_version,
      content.created_at,
      content.updated_at,
      content.published_at,
      content.new_until,
      content.origin_custom_key,
      content.cover_box,
      content.cover_rect,
      content.draft_of,
      content.replaced_by,
      content.random_order,
      content.share_link,
      content.my_draft,
      content.labels,
      content.is_popular,
      content.contents,
      content.plays
    );
  }
}
